import React, { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { CardView, Spacer } from 'design-system';
import useColors from 'hooks/useColors';
import getSymbolFromCurrency from 'currency-symbol-map';
import { useAppSelector } from 'store/hooks';
import { abbreviateNumber, abbreviateNumberWithSymbol, getPeriodKey } from '../utils/format';
import { FinancialsPeriod } from '../types';
import BarInfo from './BarInfo';
import StockFinancialCardInfoBadge from './StockFinancialCardInfoBadge';
import StockFinancialCardsHeader from './StockFinancialCardsHeader';
import Timeframe from './Timeframe';
const CashFlow = ({ assetId, selection }) => {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const periodKey = getPeriodKey(selection);
    const cashFlowData = useAppSelector((state) => state.stockInfoReducer.financials?.[assetId]?.[periodKey]?.cashflow);
    const [state, setState] = useState([]);
    useEffect(() => {
        if (cashFlowData?.length) {
            setSelectedIndex(0);
            setState(cashFlowData);
        }
    }, [selection, cashFlowData]);
    const colors = useColors();
    if (!state.length)
        return null;
    const isQuarterlySelected = selection === FinancialsPeriod.QUARTERLY && cashFlowData;
    const data = state.map((eachData) => ({
        firstBarY: eachData.cashFlow,
        thirdBarY: eachData.cashFlowFinancing || 0,
        secondBarY: eachData.totalInvestingCashFlows,
        label: isQuarterlySelected
            ? `Q${eachData.fiscalQuarter} ${String(eachData.fiscalYear).slice(-2)}`
            : String(eachData.fiscalYear),
    }));
    const freeCashFlow = state[selectedIndex].cashFlow +
        state[selectedIndex].totalInvestingCashFlows +
        (state[selectedIndex].cashFlowFinancing || 0);
    return (<CardView withPadding>
      <StockFinancialCardsHeader title="Cash flow" infoModalTitle="Cash flow" infoModalDesc="Summarises the movement of cash that comes in and out of a company."/>
      <Spacer h={16}/>
      <StockFinancialCardInfoBadge title="Free cash flow" info={`${abbreviateNumberWithSymbol(freeCashFlow, getSymbolFromCurrency(state[selectedIndex].currency))}`}/>
      <Spacer h={8}/>
      <Timeframe data={data} selectedIndex={selectedIndex} setSelectedIndex={setSelectedIndex} firstBarColor={colors.elements.income} secondBarColor={colors.elements.brand} thirdBarColor={colors.gradients.darkPink.colors[0]}/>
      <Spacer h={16}/>
      <View style={styles.barInfo}>
        <BarInfo title="Operating" color={colors.elements.income} metrics={abbreviateNumber(state[selectedIndex].cashFlow)}/>
        <BarInfo title="Investing" color={colors.elements.brand} metrics={abbreviateNumber(state[selectedIndex].totalInvestingCashFlows)}/>
        <BarInfo title="Financing" color={colors.gradients.darkPink.colors[0]} metrics={abbreviateNumber(state[selectedIndex].cashFlowFinancing)}/>
      </View>
    </CardView>);
};
export default CashFlow;
const styles = StyleSheet.create({
    barInfo: {
        flexDirection: 'row',
    },
});
